/**
 * RedBus Integration Service
 * Migrated from 3in1cms legacy/redBusAPI.ts
 */

import { request } from "../core/request";
import { OPERATION_IDS } from "./constants";
import type { IRedBusCityAPIData } from "../types/redBusTypes";

/**
 * Get RedBus city master data
 * @param city - City name keyword
 * @returns RedBus city data
 */
export const redBusAPI = async (city: string): Promise<IRedBusCityAPIData> => {
  try {
    const response = (await request<IRedBusCityAPIData, { keyWord: string }>({
      operationId: OPERATION_IDS.redBusCityMaster,
      requestData: {
        keyWord: city,
      },
    })) as IRedBusCityAPIData;

    return response;
  } catch (error) {
    console.error("Error in redBusAPI", error);
    throw error;
  }
};
